<template> 
  <div style="height: 100%">
    <template v-if="rightSectionspinner">
      <ob-spinner></ob-spinner>
    </template>
    <div id="scrollableDiv" class="rightsection-start" v-else-if="FdnsModel.FDNSQuestions && FdnsModel.FDNSQuestions.length > 0">
      <div class="row m0" v-if="isHRManager">
        <div class="Employee-right-details clearfix">
          <div class="col-md-3">
            <div class="form-group m0">
              <label>Full Name</label>
              <p class="name-txt">{{FdnsModel.Employee != null ? getEmployeeDetails(FdnsModel.Employee,'ConsultantName'):'N/A'}}</p>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group m0">
              <label>Email Address</label>
              <p class="name-txt">{{FdnsModel.Employee != null ? getEmployeeDetails(FdnsModel.Employee,'EmailAddress'):'N/A'}}</p>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group m0">
              <label>Designation</label>
              <p class="name-txt">{{FdnsModel.Employee != null ? getEmployeeDetails(FdnsModel.Employee,'Designation'):'N/A'}}</p>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group m0">
              <label>Tax Terms</label>
              <p class="name-txt">{{FdnsModel.Employee != null ? getEmployeeDetails(FdnsModel.Employee,'TaxTerms'):'N/A'}}</p>
            </div>
          </div>
        </div>
        <div class="Employee-right-details clearfix">
          <div class="col-md-3">
            <div class="form-group m0">
              <label>Visit Officer Name</label>
              <p class="name-txt">{{FdnsModel != null ? getEmployeeDetails(FdnsModel,'VisitOfficerName'):'N/A'}}</p>
            </div>
          </div>          
          <div class="col-md-3">
            <div class="form-group m0">
              <label>Visit Officer Email</label>
              <p class="name-txt">{{FdnsModel != null ? getEmployeeDetails(FdnsModel,'VisitOfficerEmail'):'N/A'}}</p>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group m0">
              <label>Visit Date</label>
              <p class="name-txt">{{FdnsModel != null ? getEmployeeDetails(FdnsModel,'VisitOfficerDate'):'N/A'}}</p>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group m0">
              <label>Visit Location</label>
              <p class="name-txt">{{FdnsModel != null ? getEmployeeDetails(FdnsModel,'VisitOfficerLocation'):'N/A'}}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="row m0" v-if="isConsultant">
        <div class="Employee-right-details clearfix">
          <div class="col-md-3">
            <div class="form-group m0">
              <label>Organization Name</label>
              <p class="name-txt">{{selectOrgDetails.OrgName =="" ? 'N/A':selectOrgDetails.OrgName }}</p>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group m0">
              <label>Organization Website</label>
              <p class="name-txt" v-html="selectOrgDetails.WebSite == '' ? 'N/A' : `<a href='${selectOrgDetails.WebSite}' title='${selectOrgDetails.WebSite}' target='_blank'>${selectOrgDetails.WebSite}</a>`"></p>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group m0">
              <label>Organization Address</label>              
              <p class="name-txt">{{selectOrgDetails.Address =="" ? 'N/A':selectOrgDetails.Address }}</p>
            </div>
          </div>          
        </div> 
        <div class="Employee-right-details clearfix">
          <div class="col-md-3">
            <div class="form-group m0">
              <label>Visit Officer Name</label>
              <p class="name-txt">{{FdnsModel != null ? getEmployeeDetails(FdnsModel,'VisitOfficerName'):'N/A'}}</p>
            </div>
          </div>          
          <div class="col-md-3">
            <div class="form-group m0">
              <label>Visit Officer Email</label>
              <p class="name-txt">{{FdnsModel != null ? getEmployeeDetails(FdnsModel,'VisitOfficerEmail'):'N/A'}}</p>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group m0">
              <label>Visit Date</label>
              <p class="name-txt">{{FdnsModel != null ? getEmployeeDetails(FdnsModel,'VisitOfficerDate'):'N/A'}}</p>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group m0">
              <label>Visit Location</label>
              <p class="name-txt">{{FdnsModel != null ? getEmployeeDetails(FdnsModel,'VisitOfficerLocation'):'N/A'}}</p>
            </div>
          </div>
        </div>
      </div>
      <list :scrollableOffsetDiff="220" scrollableDivID="scrollableDiv" :QuestionCategoryList="QuestionCategoryList" :QuestionList="QuestionList" OrgId="" :readOnly="true"></list>
    </div>
    <div class="MT-Content-table" v-else>
      <div class="MT-Content"><p>Please select a report to see the details</p></div>
    </div>
  </div>

</template>
<script>
  import List from "../../QA/List.vue";
  export default {
    props: ['selectedReport','selectOrgDetails'],
    data() {
      return {
        FdnsModel: {},
        rightSectionspinner: '',
        QuestionList: [],
        QuestionCategoryList: [],
      }
    },
    components: {
      "list": List
    },
    watch: {
      selectedReport() {
		   this.rightSectionspinner = true
        ajax.get(`/FDNSAudit/GetFDNSReportDetails?reportId=${this.selectedReport.ReportId}&empOrgId=${this.selectedReport.empOrgId}`, {}, (res) => {
			    this.rightSectionspinner = false
			    if (res.data.State == true) {
              this.FdnsModel = res.data.FdnsModel


              let arr = res.data.FdnsModel.FDNSQuestions;

                let questionList = [];

                let tempArr = [];

                let tempCat = [];

                if (arr.length > 0) {
                  arr = __.sortBy(arr, [
                    function(o) {
                      return o.QuestionCategory.Name;
                    }
                  ]);

                  let category = arr[0].QuestionCategory.Name;
                  tempCat.push(category);

                  for (var i = 0; i < arr.length; i++) {
                    if (arr[i].QuestionCategory.Name == category) {
                      tempArr.push(arr[i]);
                    } else {
                      questionList.push(tempArr);
                      tempArr = [];
                      category = arr[i].QuestionCategory.Name;
                      tempCat.push(category);
                      tempArr.push(arr[i]);
                    }
                  }

                  if (tempArr.length > 0) {
                    questionList.push(tempArr);
                  }

                  if (tempCat[tempCat.length - 1] != category) {
                    tempCat.push(category);
                  }
                }
                this.QuestionCategoryList = tempCat;
                this.QuestionList = questionList;

                let obj = {}
                obj.FdnsModel = res.data.FdnsModel
                obj.QuestionList = res.data.FdnsModel.FDNSQuestions

                this.$store.commit('updateFDNSSelectedReportDetails', obj)

          } else {
              this.ESSEnableDisable(res)
              this.$message({
                type: 'error',
                message: res.data.Message
              })
          }
			    this.rightSectionspinner = false
        });
      }

    },
    methods: {
      orgscroll(w) {
          this.toScroll(document.getElementById(w).offsetTop - 50)
		},
		getEmployeeDetails(questionCategoryValues, key) {
      if (questionCategoryValues != "" && questionCategoryValues[key] != null &&  questionCategoryValues[key] != '') {
        let docData = questionCategoryValues;
        let keyData = key;
        return docData[keyData];
      }

      return "N/A";
    }
    }
  }
</script>
<style scoped lang="scss">
  .rightsection-start {
    height: 100%;
    overflow: auto;
  }
  
  .Employee-right-details {
    background: #fff;
    padding: 10px 0 0px 0;
  }
  
  .Fdns-audit-fluid {
    padding: 0px 20px 0 20px;
  }
  
  .heading-txt {
    padding: 25px 15px 5px 22px;
    border-bottom: 1px solid #4a90e3;
    position: -webkit-sticky;
    position: sticky;
    top: -15px;
    background: #fff;
    z-index: 1;
    p {
      color: #4a90e3;
      font-size: 14px;
      font-weight: 600;
    }
  }
  
  .fdns-visithistory-right-const {
    margin: 20px 30px 20px 20px;
    label {
      color: #666;
      font-size: 14px;
      font-weight: 600;
    }
  }
  
  .answer-txt {
    display: block;
    margin: 10px 0;
    width: 100%;
    margin-left: 15px;
    font-weight: 600;
    font-size: 13px;
    color: #8e857f;
  }
  
  .Employee-right-details {
    label {
      font-size: 12px;
    }
    .name-txt {
      color: #30303f;
      font-size: 13px;
      font-weight: 600;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }
  
  .fixed-dropdown {
    position: fixed;
    right: 15px;
    top: calc(100% - 371px);
    z-index: 2;
  }
</style>
<style lang="scss">
.rightsection-start{
   .fixed-dropdown{
    position: fixed;
    right: 37px !important;
    top: 279px !important;
    z-index: 2;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/ESSProfile/FDNS/FDNSTabs/FDNSVisitHistoryTab/FDNSVisitHistoryRightSection.vue